//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @typedef {{ name: string, value: string | number }} SelectValue
 */

export default {
    model: {
        prop: 'modelValue',
        event: 'change',
    },
    props: {
        /**
         * Sets the component to use and update the model passed through v-model prop.
         *
         * When useModel is true, the v-model prop must also be set by the user of this
         * component. The model takes a string or null value.
         *
         * When using the model, the `preselected` prop is ignored and `selected` event is not
         * dispatched on change.
         */
        useModel: {
            type: Boolean,
            default: false,
        },
        // The prop used by the model. Not to be set directly by the user or changed internally.
        // Updated indirectly through dispatch of `change` event.
        modelValue: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: null,
        },
        labelledby: {
            type: String,
            default: null,
        },
        /**
         * @property {string} values[].name
         * @property {string | number} values[].value
         * @type {Vue.PropOptions<SelectValue[]>}
         */
        values: {
            type: Array,
            required: true,
        },
        preselected: {
            type: String,
            default: null,
        },
        unselected: {
            type: [Boolean, String],
            default: ' -- Select an option -- ',
        },
        required: {
            type: Boolean,
            default: false,
        },
        error: {
            type: [Boolean, String],
            default: false,
        },
        success: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isClient: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            /** @type {string | number | null} */
            selected: null,
            keyboardInput: true,
        };
    },
    computed: {
        /** @return {boolean} */
        isUnselected() {
            return this.unselected !== false;
        },
        /** @return {string | number | null} */
        currentValue() {
            return this.useModel ? this.modelValue : this.selected;
        },
        /** @return {boolean} */
        hasError() {
            return !!(typeof(this.error) === 'string' && this.error.length);
        },
    },
    watch: {
        /** @type {Vue.WatchHandler<SelectValue[]>} */
        values(values) {
            if (this.useModel) {
                const selected = values.find((val) => val.value === this.modelValue);

                if (!selected || this.modelValue !== selected.value) {
                    this.$emit('change', selected ? selected.value : null);
                }
            } else if (!(this.preselected && this.preselected === this.selected)) {
                const selected = values.find((val) => val.value === this.selected);
                this.selected = selected ? selected.value : null;
            }
        },
        /** @type {Vue.WatchHandler<string>} */
        preselected(preselected) {
            if (this.useModel) {
                return;
            }

            if (preselected) {
                this.selected = preselected;
            }
        },
    },
    created() {
        if (!this.useModel && this.preselected) {
            this.selected = this.preselected;
        }
    },
    methods: {
        /** @param {Event} e */
        change(e) {
            const target = /** @type {HTMLSelectElement} */(e.target);
            if (!this.keyboardInput) {
                target.blur();
            }
            const value = target.value;

            if (this.useModel) {
                /**
                 * @event change
                 * @property {string} value
                 */
                this.$emit('change', value);
            } else {
                this.selected = value;
                /**
                 * @event selected
                 * @property {string} name
                 * @property {string} value
                 */
                this.$emit('selected', {
                    name: this.name,
                    value,
                });
            }
        },
        focus() {
            this.keyboardInput = true;
        },
        click() {
            this.keyboardInput = false;
        },
    },
};
